var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgXirrHigh(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.24564 5.44291L12.5321 9.86323C12.7996 10.139 12.6374 10.6663 12.2852 10.6663H3.71223C3.35996 10.6663 3.19783 10.139 3.4653 9.86323L7.75176 5.44291C7.89386 5.29637 8.10354 5.29637 8.24564 5.44291Z",
    fill: "#17B55D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgXirrHigh);
export default __webpack_public_path__ + "static/media/xirr-high.c92f603e619b1c8efcfc1f2a0b6a35fc.svg";
export { ForwardRef as ReactComponent };